<template>

    <tabs-section
        class="c-field_email"
        :has-history="visit.status === 'completed'"
        :btn-label="nextLabel"
        :title="title"
        :saved="value !== null"
        @history="openHistory"
        @next="save">

        <visit-history-previous
            v-if="lastVisit !== null && lastValueExist"
            @copy="copyValue">
            {{ lastVisit[name] }}
        </visit-history-previous>

        <form-switch
            v-model="show"
            :label="switchLabel"
            @input="newValue = patient.email || ''">
        </form-switch>
        <form-input
            class="c-field_email__email"
            :class="{ 'c-field_email__email--show' : show }"
            :label="label"
            data-vv-as="email pacjenta"
            v-model="newValue"
            v-validate="'email'"
            :name="name">
        </form-input>

        <visit-history-modal ref="emailHistoryModal" :title="title" @fetched="updateHistory">
            <visit-history-item
                class="c-field_text__history"
                v-for="(item, index) in fieldHistory"
                :key="index"
                :date="item.datetime"
                :author="item.physiotherapist">
                {{ item.value }}
            </visit-history-item>
        </visit-history-modal>
    </tabs-section>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormInput, FormSwitch} from 'Components/Form'
import {TabsSection} from 'Components/Tabs'

import VisitHistoryPrevious from 'Components/Visit/VisitHistoryPrevious'
import VisitHistoryModal from 'Components/Visit/VisitHistoryModal'
import VisitHistoryItem from 'Components/Visit/VisitHistoryItem'

import noReact from 'Utils/NoReact'

export default {

    name: 'VisitFieldEmail',

    props: {
        value: String,
        name: String,
        label: String,
        switchLabel: String,
        title: String
    },

    data() {
        return {
            fieldHistory: [],
            show: !!this.value,
            newValue: noReact(this.value) || ''
        }
    },

    computed: {
        ...mapGetters(['visit', 'lastVisit', 'patient']),
        lastValueExist() {
            return typeof this.lastVisit[this.name] !== 'undefined'
                && this.lastVisit[this.name] !== null
                && this.lastVisit[this.name].trim() !== ''
        },
        nextLabel() {
            if ((!this.isEdited || (this.value === null && this.newValue.length === 0)))
                return 'Dalej'
            return 'Zapisz'
        },
        isEdited() {
            return (this.compVal !== this.value)
        },
        compVal() {
            return this.show ? this.newValue : ''
        }
    },

    methods: {
        save(nextSection) {
            if (!this.isEdited) {
                nextSection()
                return
            }
            this.$store.dispatch('VISIT_FIELD_UPDATE', {
                id: this.$route.params.id1,
                value: this.compVal,
                field: this.name
            }).then((response) => {
                this.$alert.success('Przebieg wizyty', response.data.message, 2000)
                nextSection()
            }).catch((error) => {
                this.$alert.error('Przebieg wizyty', error.response.data.message)
                nextSection(false)
            })
        },
        openHistory() {
            this.$refs.emailHistoryModal.$emit('open', this.name)
        },
        updateHistory(history) {
            this.fieldHistory = history
        },
        copyValue() {
            this.newValue = this.lastVisit[this.name]
            this.show = true
        }
    },

    components: {
        FormInput,
        FormSwitch,
        TabsSection,
        VisitHistoryPrevious,
        VisitHistoryModal,
        VisitHistoryItem
    }
}


</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-field_email {
    &__email {
        pointer-events: none;
        max-height: 0;
        opacity: 0;
        transition: opacity .2s ease-in-out, max-height .2s ease-in-out;

        &--show {
            pointer-events: auto;
            max-height: 100px;
            opacity: 1;
        }
    }
}

</style>

